// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8fb7119b","879":"2873d995"}[chunkId] + ".chunk.js";
};